import React from "react";
import { useDashboardCounts } from "../../hooks/useDashboardCounts";
import LoadingSpinner from '../ui/LoadingSpinner';

const ActiveAlarmsCard: React.FC = () => {
    const { counts, loading } = useDashboardCounts();
    const now = new Date();
    const monthLabel = now.toLocaleString(undefined, { month: 'long', year: 'numeric' });

    // Compute display total from shared counts
    const displayTotal = (counts?.activeAck ?? 0) + (counts?.activeUnack ?? 0);

    const isLoading = loading;

    if (isLoading) {
        return (
            <div className="card">
                <div className="card__content">
                    <LoadingSpinner message="Loading…" />
                </div>
            </div>
        );
    }

    return (
        <div className="card card__active-alarms" aria-live="polite">
            <div className="card__icon--alarm" />
            <div className="card__content">
                <h6>{monthLabel}</h6>
                <h2>{displayTotal.toLocaleString()}</h2>
                <span>Active Alarms (ack / unack)</span>
            </div>
        </div>
    );
};

export default ActiveAlarmsCard;